export enum DataHooks {
  WeeklyLayout = 'weekly-layout',
  Timezone = 'timezone',
}
